import { Shell } from '@thesisedu/feature-web'
import React from 'react'

import { ContentManager } from '../../custom_content/ContentManager'

export function ContentManagerOuter() {
  Shell.useShellProps('MyContent', { smallWidth: true }, [])
  return <ContentManager />
}
